import { render } from "./HomeBasketball.vue?vue&type=template&id=58d462b0&ts=true"
import script from "./HomeBasketball.vue?vue&type=script&lang=ts"
export * from "./HomeBasketball.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__